import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
                <i className="ri-timer-flash-line"></i>
                实时快讯
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
                最新快讯
              </h2>
            </div>
            <div className="hidden sm:flex items-center gap-2 text-sm text-foreground-500">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              实时更新
            </div>
          </div>

          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200">
            {updateItems.map((item, idx) => (
              <div
                key={item.id}
                className={`relative pb-8 last:pb-0 ${
                  idx === updateItems.length - 1 ? '' : ''
                }`}
              >
                <div className={`absolute -left-[25px] md:-left-[29px] w-4 h-4 rounded-full border-2 ${
                  item.isNew
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-background-50 border-background-300'
                }`}>
                  {item.isNew && (
                    <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-primary-500 animate-ping"></span>
                  )}
                </div>

                <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-xs text-foreground-400 font-mono">{item.time}</span>
                    <span className={`px-2 py-0.5 text-xs font-semibold rounded ${
                      item.isNew
                        ? 'text-background-50 bg-primary-500'
                        : 'text-secondary-700 bg-secondary-100'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 flex-1 leading-relaxed cursor-pointer hover:text-primary-600 transition-colors">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}